<template>
    <v-dialog width="700px" v-model="dialog">

        <template v-slot:activator="{ on }" class="primary">
            <v-btn
                outlined
                color="grey"
                v-on="on"
                small
            ><v-icon left>mdi-plus</v-icon>Add
            </v-btn>
        </template>

        <v-card v-if="dialog">
            <v-card-title>
                <span class="headline">Add a New Shift, {{periodDate | formatDate}}</span>
                <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
            </v-card-title>
            <v-card-text>
                <v-row align="stretch">
                    <!-- right panel -->
                    <v-col cols="12">
                        <v-form ref="form">
                            <v-row>

                                <v-col cols="12" sm="6" md="6">
                                    <v-autocomplete
                                        class="hide-time-picker-indicator"
                                        type="time"
                                        menu-props="auto, overflowY"
                                        clear-icon="mdi-close"
                                        prepend-icon="mdi-clock-outline"
                                        clearable
                                        outlined
                                        label="Start Time*"
                                        hint="Example: 08:00"
                                        required
                                        v-model="start_time"
                                        :items="timeList"
                                        item-text="name"
                                        item-value="value"
                                        :error-messages="startTimeErrors"
                                        open-on-clear
                                        v-on:focus="onStartTimeFocused"
                                        v-on:input="onStartTimeChanged"
                                        v-on:blur="onStartTimeBlur"
                                        dense
                                    >
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-autocomplete
                                        class="hide-time-picker-indicator"
                                        type="time"
                                        menu-props="auto, overflowY"
                                        clear-icon="mdi-close"
                                        prepend-icon="mdi-clock-outline"
                                        clearable
                                        outlined
                                        label="Finish Time*"
                                        hint="Example: 18:30"
                                        required
                                        v-model="finish_time"
                                        :items="timeList"
                                        item-text="name"
                                        item-value="value"
                                        :error-messages="finishTimeErrors"
                                        open-on-clear
                                        v-on:focus="onFinishTimeFocused"
                                        v-on:input="onFinishTimeChanged"
                                        v-on:blur="onFinishTimeBlur"
                                        dense
                                    >
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-autocomplete
                                        prepend-icon="mdi-wallet-giftcard"
                                        label="Add Driver Bonus"
                                        item-text="name"
                                        item-value="id"
                                        v-model="cost_bonus"
                                        :items="bonus_list"
                                        required
                                        outlined
                                        dense
                                    >
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                        type="number"
                                        prepend-icon="mdi-gas-station"
                                        label="Add Fuel Bonus"
                                        v-model="const_fuel_bonus"
                                        required
                                        outlined
                                        dense
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12">
                                    <v-textarea
                                        outlined
                                        label="Comment"
                                        v-model="comment"
                                    ></v-textarea>
                                </v-col>

                            </v-row>

                            <div class="d-flex justify-center">
                                <v-btn
                                        depressed
                                        class="mr-4 primary"
                                        :disabled="this.$v.$invalid || localLoading"
                                        :loading="localLoading"
                                        @click="submit"
                                ><v-icon left>mdi-upload</v-icon>Create <span class="hidden-sm-and-down">Shift</span></v-btn>
                                <v-btn
                                        class="mr-4"
                                        :loading="localLoading"
                                        depressed
                                        @click="clear"
                                ><v-icon left>mdi-rotate-left</v-icon><span class="hidden-sm-and-down">Clear</span></v-btn>
                                <v-btn
                                        class="mr-4 warning"
                                        :loading="localLoading"
                                        depressed
                                        @click="dialog=false"
                                ><v-icon left>mdi-cancel</v-icon>Cancel</v-btn>
                            </div>

                        </v-form>
                    </v-col>
                    <!--/ right panel -->
                </v-row>
            </v-card-text>
        </v-card>
        
    </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required,/* maxLength, email, numeric */ } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import moment from 'moment';

export default {
    mixins: [validationMixin],
    name: "NewShiftModal",
    props: ['restaurantItem', 'periodDate'],
    validations: {
        // driver_id: { required },
        start_time: { required,/* maxLength: maxLength(10)*/ },
        finish_time: { required },
        comment: { }
    },
    data: () => ({
        /*valid: false,*/
        readOnly: false,
        localLoading: false,
        dialog: false,
        // --
        restaurant_id: '',
        // driver_id: 0,
        // status: '10',
        period_date: '',
        start_time: '',
        finish_time: '',
        // cost_per_hour: '',
        // cost_total: '',
        cost_bonus: 0,
        const_fuel_bonus: 0,
        cost_extra_bonus: 0,
        comment: '',
        // --
        area_selected: void 0,
        bonus_list: [
            {id: 0, name: 'no bonus'},
            {id: 10, name: '+£10'},
            {id: 20, name: '+£20'},
        ],
        start_time_was_clean: false,
        finish_time_was_clean: false,
    }),
    updated() {

    },
    computed: {
        ...mapGetters(['timeList']),
        startTimeErrors () {
            const errors = [];
            if (!this.$v.start_time.$dirty) {
                return errors;
            }
            !this.$v.start_time.required && errors.push('Start Time is required.')
            !moment(this.$data.start_time, "HH:mm").isValid() && errors.push('Start Time invalid format.')
            return errors
        },
        finishTimeErrors () {
            const errors = [];
            if (!this.$v.finish_time.$dirty) {
                return errors;
            }
            !this.$v.finish_time.required && errors.push('Start Time is required.')
            !moment(this.$data.finish_time, "HH:mm").isValid() && errors.push('Finish Time invalid format.')
            return errors
        },
        /**
         * calculate Shift Length
         * result: (finish_time - start_time)
         */
        shiftLength: function() {
            let finish_time = moment(this.$data.finish_time, "HH:mm");
            let start_time = moment(this.$data.start_time, "HH:mm");
            if (!finish_time.isValid() || !start_time.isValid()) {
                return 0;
            }

            if (this.$data.finish_time < this.$data.start_time) {
                finish_time.add(1, 'days');
            }

            let total_time_hours = ( (finish_time - start_time) / (60 * 1000) ) / 60;

            return total_time_hours.toFixed(2); // round
        },
    },

    methods: {
        submit () {
            this.localLoading = true;
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$data.restaurant_id = this.$props.restaurantItem.id;
                this.$data.period_date = this.$props.periodDate;

                const newShift = {
                    restaurant_id: this.$data.restaurant_id,
                    // driver_id: this.$data.driver_id,
                    // status: void 0,
                    period_date: this.$data.period_date,
                    start_time: this.$data.start_time,
                    finish_time: this.$data.finish_time,
                    meal_time: 0,
                    rest_time: 0,
                    cost_per_hour: 0, //?
                    cost_total: 0, //?
                    cost_bonus: this.$data.cost_bonus,
                    const_fuel_bonus: this.$data.const_fuel_bonus,
                    cost_extra_bonus: this.$data.cost_extra_bonus,
                    comment: this.$data.comment,
                    // created_at: void 0,
                    // updated_at: void 0,
                };

                // if (newShift.driver_id == 0) { // fix 0 to null
                //     newShift.driver_id = null;
                // }

                this.$store.dispatch('createNewFreeShift', newShift).then(() => {
                    this.dialog = false;
                    this.clear();
                }).finally(() => {
                    this.localLoading = false;
                });
            }
        },
        clear () {
            this.$v.$reset();
            // this.driver_id = 0;
            this.start_time = '';
            this.finish_time = '';
            this.cost_bonus = 0;
            this.const_fuel_bonus = 0;
            this.cost_extra_bonus = 0;
            this.comment = '';
        },
        // -- select current time on click
        onStartTimeFocused: function() {
            if (!this.start_time) {
                this.start_time = this.timeToApproximation(moment().format('HH:mm'));
                this.start_time_was_clean = true;
            }
        },
        onStartTimeChanged: function() {
            this.$v.start_time.$touch();
            this.start_time_was_clean = false;
        },
        onStartTimeBlur: function () {
            if (this.start_time_was_clean) {
                this.start_time = void 0;
            }
            this.$v.start_time.$touch(); // fire validation
        },
        onFinishTimeFocused: function() {
            if (!this.finish_time) {
                this.finish_time = this.timeToApproximation(moment().format('HH:mm'));
                this.finish_time_was_clean = true;
            }
        },
        onFinishTimeChanged: function() {
            this.$v.finish_time.$touch();
            this.finish_time_was_clean = false;
        },
        onFinishTimeBlur: function () {
            if (this.finish_time_was_clean) {
                this.finish_time = void 0;
            }
            this.$v.finish_time.$touch(); // fire validation
        },
        // -- END select current time on click
        timeToApproximation: function(time_src) {
            let time_src_m = moment(time_src, "HH:mm:ss");
            if (!time_src_m.isValid()) {
                return time_src;
            }

            let time_item = _.find(this.timeList, p => {
                let time_item = moment(p.value, "HH:mm");
                let time_approximation = (time_item - time_src_m) / (1000 * 60 * 60)
                return time_approximation > -0.125;
            });

            if (time_item) {
                return time_item.value;
            }

            return time_src;
        },
    },
    filters: {
      formatDate: function (date) {
        return moment(date, "YYYY-MM-DD").format('MMM Do');
      },
    },
}
</script>

<style scoped>

</style>